import clsx from 'clsx';
import { separator } from './separator.css';

export const Separator = ({ className }: { className?: string }) => (
  <hr className={clsx(separator, className)} />
);
